import { resolveBg, sanitizeSvg } from '../lib/templateBackgrounds';

/**
 * 模板背景层：把背景 SVG 内联到 DOM（SMIL 动画因此可正常播放），
 * 绝对定位铺满容器、置于内容之下（-z-10），由外层 `relative isolate` 容器约束层级。
 */
export default function TemplateBackground({
  slug,
  bgSvg,
  className = '',
}: {
  slug: string;
  bgSvg?: string | null;
  className?: string;
}) {
  const html = sanitizeSvg(resolveBg(slug, bgSvg));
  if (!html) return null;
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 -z-10 overflow-hidden select-none ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
